<template>
  <span>
    <i :class="paymentList[paymentType].icon"></i> {{ iconOnly ? '' : paymentList[paymentType].description }}
  </span>
</template>

<script>

  import FinancialService from "@/services/financial-service"

  export default {

    data() {
      return {
        paymentList: FinancialService.PAYMENT_TYPE,
      }
    },

    props: ["paymentType", "iconOnly"], 

  }
</script>